/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useSelector } from "react-redux";
import PageLayout from "../../containers/PageLayout";
import CarrierManagementTable from "../carrier-management/CarrierManagementTable";
import CarrierManagementFilters from "./CarrierManagementFilters";
import CarrierManagementSubMenu from "./CarrierManagementSubMenu";
import TierSettings from "../TierSettings";
import types from "../../helpers/types";

export const CarrierManagementSubMenuItems = {
    CARRIER_SEARCH: "carrier search",
    TIER_SETTINGS: "tier settings",
};

const CarrierManagementContainer = () => {
    const [panel, setPanel] = useState(
        CarrierManagementSubMenuItems.CARRIER_SEARCH
    );

  return (
    <PageLayout
      pageTitle="Carrier Management"
      documentTitle="RouteConnect™ - Carrier Management"
      data-testid="gotrack-carrier-management"
      contentPlaceholder={<CarrierManagementSubMenu setPanel={(panel) => setPanel(panel)} />}
    >
      {panel == CarrierManagementSubMenuItems.TIER_SETTINGS && <TierSettings />}
      {panel == CarrierManagementSubMenuItems.CARRIER_SEARCH && <CarrierManagementFilters />}
      {panel == CarrierManagementSubMenuItems.CARRIER_SEARCH && <CarrierManagementTable />}
    </PageLayout>
  );
};

export default CarrierManagementContainer;
